import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import PrimeVue from 'primevue/config';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Material from '@primeuix/themes/material';  // or another theme preset
import Column from 'primevue/column';
import InputText from "primevue/inputtext";
import ToastService from 'primevue/toastservice';
import DialogService from "primevue/dialogservice";
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import 'primeicons/primeicons.css';

const app = createApp(App);
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: Material,
        options: {
            prefix: 'p',
            darkModeSelector: 'system',
            cssLayer: false
        }
    }
});
app.use(ToastService);

app.use(DialogService);

app.component('PrimeButton', Button);
app.component('PrimeDataTable', DataTable);
app.component('PrimeColumn', Column);
app.component('PrimeInputText', InputText);
app.component('PrimeDialog', Dialog);
app.component('PrimeDropdown', Dropdown);
app.component('PrimeToast', Toast);
app.mount('#app');